import React from 'react'
import Footer from './Footer'
// import { Helmet } from 'react-helmet'
import Header from './Header'
const Layout = ({ children }) => {
    return (
        <>
            {/* <Helmet> */}
            {/* Bootstrap CSS */}
            {/* <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" /> */}

            {/* FontAwesome */}
            {/* <link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css" /> */}

            {/* <!-- CAROUSEL SLIDER --> */}
            {/* <link rel="stylesheet" type="text/css" href="https://cdn.jsdelivr.net/gh/kenwheeler/slick@1.8.1/slick/slick-theme.css" />
                <link rel="stylesheet" type="text/css" href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css" /> */}

            {/* Lottie */}
            {/* <script src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"></script> */}

            {/* jQuery */}
            {/* <script src="https://cdn.jsdelivr.net/npm/jquery@3.5.1/dist/jquery.slim.min.js"></script> */}

            {/* BOOTSTRAP CDN */}
            {/* <script src="https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/js/bootstrap.min.js"></script> */}

            {/* <title>CodeFrenetics</title>
            </Helmet> */}

            <Header />
            {children}
            <Footer />
        </>
    )
}

export default Layout

